"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ConfigurationError;
// eslint-disable-next-line no-unused-vars
function ConfigurationError(code, message) {
  var instance = new Error(message);
  instance.message = message;
  instance.code = code;
  Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
  if (Error.captureStackTrace) {
    Error.captureStackTrace(instance, ConfigurationError);
  }
  return instance;
}
ConfigurationError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
if (Object.setPrototypeOf) {
  Object.setPrototypeOf(ConfigurationError, Error);
} else {
  ConfigurationError.__proto__ = Error;
}